<template>
  <div id="viewSTLDIV" >
      <canvas v-show='viewSTL && !isLoadingSTL' id="viewSTL" class="viewSTL black " width="350" height="350" max-width="100%"></canvas>

      <v-container style="height: 350px;" v-show='viewSTL && isLoadingSTL'>
        <v-row
          class="fill-height"
          align-content="center"
          justify="center"
        >
          <v-col
            class="text-subtitle-1 text-center"
            cols="12"
          >
            {{ $t('global.loading')}}
          </v-col>
          <v-col cols="6">
            <v-progress-linear
              color="primary accent-4"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
      <ImageView v-if="!viewSTL" :item="item" height="350" width="350" filter="400x400" :edit="userHasAccess('designfile_edit') && edit" :download="edit" />
      <v-btn
        :loading="isLoading"
        class="ml-sm-2"
        color="primary"
        v-if="userHasAccess('designfile_edit')"
        @click="exportToImage"
      >
        {{ $t('designfile.changeviewer')}}
      </v-btn>

  </div>

</template>

<script>
import * as THREE from 'three';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader.js';
import ImageView from './ImageView.vue';
import FileMixin from '../mixins/FileMixin';
import AccessMixin from '../mixins/AccessMixin';
  import { mapFields } from 'vuex-map-fields';

export default {
  name: 'STLView',
  servicePrefix: 'STLView',
  mixins: [FileMixin,AccessMixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    edit: {
      type: Boolean,
      required: false,
      default: true
    },
    bigfile: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  components: {
    ImageView,
  },
  data() {
    return {
      canvas: null,
      container: null,
      camera: null,
      cameraTarget: null,
      scene: null,
      renderer: null,
    }
  },
  mounted() {
    if(this.viewSTL) {
      this.downloadFileBlob();
    }
  },
  computed: {
    isLoadingSTL() {
      return (this.isLoading_mediaobject
       );
    },
    ...mapFields('mediaobject', {
      isLoading_mediaobject : 'isLoading'
    }),
    isBigFile() {
      if(this.bigfile) {
        return false;
      }
      if (this.item) {
        if (this.item['file']) {
          if (this.item['file'].fileSize > 10000000) {
            return true;
          }
        }
      }
      return false;
    },
    viewSTL() {
      if (this.item['file']) {
        let filepath = this.item['file'].filePath;
        let extension = filepath.substring(filepath.lastIndexOf('.') + 1);
        if (extension == 'zip' || extension == 'ZIP' ) {
          return false;
        }
      }
      if (this.isBigFile) {
        if(this.item['image']) {
          return false;
        }
      }
      return true;
    }
  },
  methods: {

    initViewerSTL(stlBlob) {
      this.canvas = document.getElementById('viewSTL');
      this.container = document.getElementById('viewSTLDIV');
      if (this.canvas) {
        this.canvas.getContext("experimental-webgl", {preserveDrawingBuffer: true})
        // Scene
        const scene = new THREE.Scene();
      //  scene.background = new THREE.Color( 0x72645b );

        // Camera
        const camera = new THREE.PerspectiveCamera( 50, 1, 1, 2000 );
        camera.position.set(0,-3,0);
        camera.lookAt(0,0,0);

        // STL
        const renderer = new THREE.WebGLRenderer({ canvas: this.canvas, antialias: true, preserveDrawingBuffer: true });
        const loader = new STLLoader();
        let mesh = null;

        loader.load( stlBlob, function ( geometry) {
          var material = new THREE.MeshPhongMaterial({ color: 0xfdb913, specular: 0x111111, shininess: 200 });

          geometry.computeBoundingSphere();
          geometry.scale(1/geometry.boundingSphere.radius, 1/geometry.boundingSphere.radius, 1/geometry.boundingSphere.radius );
          geometry = geometry.center();
          mesh = new THREE.Mesh(geometry , material );

          scene.add(mesh);
        } );

        // Lights
        scene.add( new THREE.HemisphereLight( 0xfdb913, 0x111122 ) );
        this.addShadowedLight(scene, 1, 1, 1, 0xfdb913, 1.35 );
        this.addShadowedLight(scene, 0.5, 1, - 1, 0xfdb913, 1 );
        this.addShadowedLight(scene, 1, -1, 1, 0xfdb913, 1.35 );

        const animate = function () {
          requestAnimationFrame( animate );
          if (mesh) {

            mesh.rotation.z += 0.01;
            mesh.rotation.x += 0.01;
            mesh.rotation.y += 0.01;


/*
            if (mesh.rotation.z % 3.14 > 0.1) {
              mesh.rotation.z += 0.01;
              passe = true;
            } else if ( (mesh.rotation.z - mesh.rotation.x > 0.1) && !passe)  {
              mesh.rotation.x += 0.01;
              passe = true;
            }
            if (! passe) {
              mesh.rotation.z += 0.01;
            }
*/
          }

          renderer.render( scene, camera );
        };
        animate();
        if (! this.item['image']) {
          // sleep pour ne pas avoir un ecran noir
          setTimeout(() => {
            console.log('create image');
            this.exportToImage();
          }, 2000);

        }


      }

    },
    addShadowedLight(scene, x, y, z, color, intensity ) {
				const directionalLight = new THREE.DirectionalLight( color, intensity );
				directionalLight.position.set( x, y, z );
				scene.add( directionalLight );
				directionalLight.castShadow = true;
				const d = 1;
				directionalLight.shadow.camera.left = - d;
				directionalLight.shadow.camera.right = d;
				directionalLight.shadow.camera.top = d;
				directionalLight.shadow.camera.bottom = - d;
				directionalLight.shadow.camera.near = 1;
				directionalLight.shadow.camera.far = 4;
				directionalLight.shadow.bias = - 0.002;
		},
    exportToImage() {
      var canvas = document.getElementById( 'viewSTL' );
      var ImageURL = canvas.toDataURL('image/png');
      this.inputfile =  this.dataURIToBlob(ImageURL);

      this.uploadFileCreateItem(this.item['id'],this.item['@entity'],this.inputfile);
    },
    dataURIToBlob(dataURI) {
      const splitDataURI = dataURI.split(',')
      const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
      const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

      const ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i++)
          ia[i] = byteString.charCodeAt(i)

      return new Blob([ia], { type: mimeString })
    },
  },
  watch: {
    blob: function (blob) {
      this.initViewerSTL(blob);
    },
  }
};
</script>
